import React from 'react'
import { FormattedMessage } from 'react-intl'
import { SMALL_SIZE } from 'assets/CloudinaryURLHelper'
import { Box, Typography } from '@material-ui/core'
import { Image, Transformation } from 'cloudinary-react'
import { useStyles } from '../SchoolShow_style'
import IconFactory from 'icons/IconFactory/IconFactory'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import Paper from 'components/Paper/Paper'

const FacultyCard = (props) => {
    const { faculty } = props
    const classes = useStyles()

    return (
        <Paper className={classes.facultyCardPaper}>
            <Image
                alt={`${faculty.title} banner`}
                cloudName="studentbe"
                className={classes.facultyCardImage}
                publicId={faculty.image?.cloudinary_key}
            >
                <Transformation flags="progressive" fetchFormat="auto" height={SMALL_SIZE} quality="auto:good" crop="fill" />
            </Image>
            <Box className={classes.facultyCardBody}>
                <Box className={classes.facultyCardContent}>
                    <Typography variant='h2' component='h3' className={classes.facultyCardTitle}>
                        {faculty.title}
                    </Typography>
                    <Typography
                        component='p'
                        dangerouslySetInnerHTML={{ __html: faculty.description }}
                    />
                </Box>
                <RouteMapLink target='_blank' redirectionUrl={faculty.url} className={classes.facultyCardmoreInfoUrl}>
                    <Typography variant='h6' component='p'>
                        <FormattedMessage id='school_page.faq.more_info_url'/>
                    </Typography>
                    <IconFactory icon='circle-arrow-right' className={classes.faqArrow}/>
                </RouteMapLink>
            </Box>
        </Paper>
    )
}

export default FacultyCard
